/** Fallback visible cuando la API no trae unidad conocida (columna Unidad, precio sugerido). */
export const SUPPLY_UNIT_UNKNOWN_LABEL = '—';

export type SupplyUnitFields = {
  unit_abbreviation?: string | null;
  unit_name?: string | null;
};

export function resolveSupplyUnitDisplay(
  item: SupplyUnitFields,
): { abbreviation: string; name: string } {
  const abbr = (item.unit_abbreviation ?? '').trim();
  const name = (item.unit_name ?? '').trim();
  if (abbr) {
    return { abbreviation: abbr, name: name || abbr };
  }
  if (name) {
    return { abbreviation: name, name };
  }
  return { abbreviation: SUPPLY_UNIT_UNKNOWN_LABEL, name: SUPPLY_UNIT_UNKNOWN_LABEL };
}

type SupplyUnitRow = SupplyUnitFields & {
  supplier_id?: number | null;
  available_suppliers?: Array<
    SupplyUnitFields & {
      supplier_id: number;
    }
  >;
};

export function resolveSupplyUnitForProductRow(
  item: SupplyUnitRow,
  contextualSupplierId?: number | null,
): { abbreviation: string; name: string } {
  if (
    contextualSupplierId != null
    && contextualSupplierId !== item.supplier_id
  ) {
    const supplier = item.available_suppliers?.find(
      (s) => s.supplier_id === contextualSupplierId,
    );
    if (supplier) {
      return resolveSupplyUnitDisplay(supplier);
    }
  }
  return resolveSupplyUnitDisplay(item);
}
